import { Heading, Text } from '../ui/index.js'

/**
 * Every list gets one, and it says what to do next. A screen that only looks right with
 * data is unfinished - docs/runbook/04-design-system.md §4.
 */
export function EmptyState({
  title,
  hint,
  action,
}: {
  title: string
  hint?: string
  action?: React.ReactNode
}) {
  return (
    <div className="state-block">
      <Heading type="h3">{title}</Heading>
      {hint !== undefined ? <Text color="secondary">{hint}</Text> : null}
      {action}
    </div>
  )
}
